import React from 'react';
import { makeStyles, createStyles, Grid } from '@material-ui/core';

import { PageLocation } from '../../../shared/enum/PageLocation';
import { HomeContext } from '../../Home/HomeContext';
import { ClipperInput } from './ClipperInput';
import { ClipperContext } from '../ClipperContext';
import { ClipperSearch } from './ClipperSearch';
import { clipperDataInitial, ClipperModel } from '../../../Models/ClipperModel';

const useStyles = makeStyles(() => createStyles({
    gridContainer: {
        maxWidth: '1152px',
        margin: 0
    },
}));
 
export function Clipper() {
    const classes = useStyles();    

    const homeContext = React.useContext(HomeContext);

    const [clipper, setClipper] = React.useState<ClipperModel>(clipperDataInitial);
    
    return (
        <ClipperContext.Provider value={{
            clipper, setClipper
        }}>
            <Grid container justify="center" alignItems="center">
                <Grid container justify="center" className={classes.gridContainer} spacing={2}>   
                    {homeContext.pageLocation === PageLocation.CLIPPER_INPUT && <ClipperInput /> }
                    {homeContext.pageLocation === PageLocation.CLIPPER_EDIT && <ClipperInput /> }
                    {homeContext.pageLocation === PageLocation.CLIPPER_SEARCH && <ClipperSearch /> }
                </Grid>
            </Grid>
        </ClipperContext.Provider>
    );
}